module.exports = __webpack_public_path__ + "static/media/outline-sound-icon-active.e3b612d7.svg";